import { render, staticRenderFns } from "./TPAEnrollees.vue?vue&type=template&id=d9ed83e6&"
import script from "./TPAEnrollees.vue?vue&type=script&lang=js&"
export * from "./TPAEnrollees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports